import angular from 'angular';
import CSMCommonWeb from 'csm-common-web';

export default angular
  .module('entitiesAdmin.data', [CSMCommonWeb])
  .factory('EntityAdminListItem', entityAdminListItemFactory)
  .name;

/* @ngInject */ function entityAdminListItemFactory(EntityListItem, Tools) {
  /*****************************************************************************
   * Constants
   *****************************************************************************/
  /*--------*/
  /* Colors */
  /*--------*/
  /** Active Record/Default. */ var COL_DEFAULT = 'default';
  /** Inactive Record. */ var COL_INACTIVE = 'inactive';
  /** Valid Login. */ var COL_VALID = 'valid';
  /** Expired Login. */ var COL_EXPIRED = 'expired';

  function EntityAdminListItem(src) {
    EntityListItem.call(this, src);

    /***************************************************************************
     * Properties
     ***************************************************************************/
    /** Self Reference. */ var mThis = this;

    /** Current Membership Year */ mThis.membershipYear;
    /** Login Expired */ mThis.loginExpired;
    /** Login Role */ mThis.role;
  }

  /** Set the prototype from the parent class. */
  EntityAdminListItem.prototype = EntityListItem.prototype;

  /** Returns true if the entity has a login record. */
  Object.defineProperty(EntityAdminListItem.prototype, 'hasLogin', {
    get: function () {
      return !Tools.isNaNZero(this.loginID);
    }
  });

  /** Active Text Color Indicator. */
  Object.defineProperty(EntityListItem.prototype, 'textColor', {
    get: function () {
      return this.active ? COL_DEFAULT : COL_INACTIVE;
    }
  });

  /** Role Expiration Text Color. */
  Object.defineProperty(EntityAdminListItem.prototype, 'roleTextColor', {
    get: function () {
      return this.hasLogin
        ? this.loginExpired
          ? COL_EXPIRED
          : COL_VALID
        : this.textColor;
    }
  });

  /** Student ID label. Shows Grade if available. */
  Object.defineProperty(
    EntityAdminListItem.prototype,
    'studentGradeLabel',
    {
      get: function () {
        return ''.concat(
          this.studentID,
          ' ',
          this.isStudent && angular.isNumber(this.grade)
            ? '(' + this.grade.toString() + ')'
            : ''
        );
      }
    }
  );

  return EntityAdminListItem;
};
